var heading_default = {
  "fontElementMap": "bJuMP",
  "elementSpacing": "jPJNj",
  "headerOne": "Mr83k jPJNj",
  "headerTwo": "e6bES jPJNj",
  "headerThree": "h1Yfm jPJNj",
  "headerFour": "Hjc-G jPJNj",
  "headerFive": "_3HoKu jPJNj",
  "headerSix": "uG8gT jPJNj",
  "child": "_75FQy"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
